import { render, staticRenderFns } from "./ThreeDimensions.vue?vue&type=template&id=91a3f89e"
import script from "./ThreeDimensions.vue?vue&type=script&lang=js"
export * from "./ThreeDimensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports